import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { NotFound } from "~/pages/NotFound";
import { AppLayout } from "~/components/layouts/app-layout";

export const Route = createFileRoute("/_app")({
  beforeLoad: ({ context }) => {
    const { session } = context.auth;

    if (!session) {
      throw redirect({ to: "/login" });
    }

    return { session };
  },
  component: AppRoute,
  notFoundComponent: NotFound,
});

function AppRoute() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
